import React from 'react';
import { BusinessJobResponse } from '../models';
import { Grid } from '@mui/material';
import { BusinessSlot, ShiftJob, ShiftProviderUser } from 'models';
import { formatMinutesFromDate } from 'shared/Dates';
import { TitleDescription } from './TitleDescription';

export function BusinessSlotSchedule({
    slot,
    job,
    provider,
    recruitmentStatuses,
}: {
    slot: BusinessSlot;
    job: BusinessJobResponse['job_details'] | ShiftJob;
    provider?: ShiftProviderUser;
    recruitmentStatuses: { title: string; show: boolean }[];
}) {
    const recruitmentStatus = recruitmentStatuses.find((s) => s.show)?.title ?? 'Shift Posted';
    return (
        <Grid item container direction="row" style={{ marginTop: 5, gap: 20 }}>
            <TitleDescription
                title={'Schedule'}
                description={`${formatMinutesFromDate(slot.start_date)} - ${formatMinutesFromDate(slot.end_date)}`}
            />
            <TitleDescription
                title={job.pay ? 'Pay' : 'Pay Scale'}
                description={job.pay ? `${job.pay}/hr` : `${job.rate_min} - ${job.rate_max}/hr`}
            />
            {provider ? null : <TitleDescription title="Confirmed Worker" description={recruitmentStatus} />}
        </Grid>
    );
}
